
<div class="container flex" [class.full-width]="fullWidth" [class.hide-icons]="hideIcons">
  @if (alwaysExpanded && !hideIcons) {
    <button type="button" class="text-btn-16 flex-center lupa-icon-btn" tabindex="-1"
            nz-button [nzType]="'text'" nzShape="circle" nzSize="large">
      <app-st-icon class="flex-center" [name]="'search'" [bold]="true" [color]="'#8F8F8F'"></app-st-icon>
    </button>
  }
  <div class="input-wrapper" [class.shrinked]="!alwaysExpanded && !showInput"
       [class.hide-icons]="hideIcons"
       [class.wide]="wide"
       [class.has-clean]="hasAnySearchValue() && !hideIcons"
       [class.no-transition]="shouldDisableTransition && !hasAnySearchValue()"
       [class.w-100]="(screenService.isMobile$ | async) || fullWidth"
       [class.full-width]="fullWidth">
    @if (parallelSearchMode && (showInput || alwaysExpanded)) {
      <div class="parallel-mode-area">
        @for (term of activeTerms; track $index) {
          <span class="search-badge">
            {{ term }}
            <app-st-icon (click)="removeTerm($index)" class="badge-close" [bold]="true" name="close" [color]="'#8F8F8F'"></app-st-icon>
          </span>
        }
        <input #searchInput
               (ngModelChange)="onInputChangeParallel($event)"
               (paste)="onPasteParallel($event)"
               (keydown.escape)="onEscapeKey()"
               (blur)="onInputBlur()"
               nzSize="large" type="text"
               nz-input [placeholder]="activeTerms.length ? '' : placeholder"
               [ngModel]="currentInputValue"/>
      </div>
    } @else {
      <input #searchInput
             (ngModelChange)="search($event)"
             (keydown.escape)="onEscapeKey()"
             (blur)="onInputBlur()"
             nzSize="large" type="text"
             nz-input [placeholder]="showInput || alwaysExpanded ? placeholder : ''"
             [ngModel]="searchValue"/>
    }
    @if (hasAnySearchValue() && !hideIcons) {
      <app-st-icon (click)="isJustClear = true; onInputBlur()"
                   class="clean-preffix" [bold]="true" name="close" [color]="'#8F8F8F'"></app-st-icon>
    }
  </div>

  @if (showParallelToggle && (showInput || alwaysExpanded)) {
    <button type="button"
            (mousedown)="$event.preventDefault()"
            (click)="toggleParallelMode(); focusSearchInput()"
            class="text-btn-16 flex-center parallel-toggle-btn"
            [nz-tooltip]="parallelToggleTooltip"
            nzTooltipPlacement="bottom"
            nz-button
            [nzType]="parallelSearchMode ? 'primary' : 'default'"
            nzShape="circle"
            nzSize="large">
      <app-st-icon class="flex-center" [name]="'filter_list'" [bold]="true"
                   [color]="parallelSearchMode ? '#fff' : '#8F8F8F'"></app-st-icon>
    </button>
  }

  @if (!alwaysExpanded && !hideIcons) {
    <button (click)="toggleShowInput()" class="text-btn-16 flex-center" nz-button style="border: none"
            [nzType]="'text'" nzShape="circle" nzSize="large">
      <app-st-icon class="flex-center" [name]="'search'" [bold]="true" [color]="'#8F8F8F'"></app-st-icon>
    </button>
  }
</div>
